module.exports = __webpack_public_path__ + "static/media/GA_Post_do-posle-2.20371f7a.jpg";